import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import { Input, Label, Form, FormGroup, FormText } from "reactstrap";

import CustomTextButton from "components/Custom/Buttons/TextButton";
import { getBase64 } from "utils";
import { createNewNft, toggleModal } from "store/actions";

const CreateNewNft = () => {
    const dispatch = useDispatch();

    const [base64Img, setBase64Img] = useState("");
    const [imgPath, setImgPath] = useState("");

    const imgToBase64 = async (file) => {
        let data = await getBase64(file);
        setBase64Img(data);
    };

    return (
        <div>
            <Formik
                initialValues={{
                    name: "",
                    description: "",
                    royalty: 0,
                    artwork: imgPath,
                }}
                validationSchema={Yup.object().shape({
                    name: Yup.string().max(255).required("Name is required"),
                    // artwork: Yup.string().required("Artwork is required"),
                })}
                onSubmit={(value) => {
                    value.artwork = base64Img;
                    dispatch(toggleModal(false));
                    dispatch(createNewNft(value));
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                    <div style={{ padding: "1em" }}>
                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Label>Name</Label>
                                <Input
                                    key="name"
                                    name="name"
                                    type="text"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                />
                                {Boolean(touched.name && errors.name) ? (
                                    <div style={{ display: "block", marginLeft: "10px", color: "red", fontSize: 12 }}>
                                        {errors.name}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </FormGroup>

                            <FormGroup>
                                <Label>Description</Label>
                                <Input
                                    key="description"
                                    name="description"
                                    type="textarea"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.description}
                                />
                                {Boolean(touched.description && errors.description) ? (
                                    <div style={{ display: "block", marginLeft: "10px", color: "red", fontSize: 12 }}>
                                        {errors.description}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </FormGroup>

                            <FormGroup>
                                <Label>Artwork</Label>
                                <Input
                                    type="file"
                                    name="artwork"
                                    onChange={(e) => {
                                        setImgPath(e.target.value);
                                        imgToBase64(e.target.files);
                                    }}
                                    onBlur={handleBlur}
                                    accept="image/*"
                                />
                                <FormText color="muted">Select artwork for converting to NFT</FormText>
                                {Boolean(touched.artwork && errors.artwork) ? (
                                    <div style={{ display: "block", marginLeft: "10px", color: "red", fontSize: 12 }}>
                                        {errors.artwork}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </FormGroup>

                            <FormGroup>
                                <Label>Royalty in Percentage</Label>
                                <Input
                                    key="royalty"
                                    name="royalty"
                                    type="number"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.royalty}
                                />
                                {Boolean(touched.royalty && errors.royalty) ? (
                                    <div style={{ display: "block", marginLeft: "10px", color: "red", fontSize: 12 }}>
                                        {errors.royalty}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </FormGroup>
                            <div>
                                <CustomTextButton
                                    title="Create NFT"
                                    style={{ width: "100%" }}
                                    onClick={handleSubmit}
                                    disabled={values.name === "" || base64Img === ""}
                                    type="submit"
                                />
                            </div>
                        </Form>
                    </div>
                )}
            </Formik>
        </div>
    );
};

export default CreateNewNft;
